import React, { useState } from "react";
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import editPhotoIcon from 'assets/icons/editPhotoIcon.svg';

interface IProfilePhotoViewer {
  isLoading: boolean;
  photoSrc?: string;
  t: (key: string, params?: {}) => any;
  onPhotoError?: () => any;
}

const ProfilePhotoViewer: React.FC<IProfilePhotoViewer> = ({ isLoading, photoSrc, t, onPhotoError }) => {
  const [isHoveringPhoto, setIsHoveringPhoto] = useState<boolean>(false);
  if (photoSrc) {
    const photoSrcUrl = photoSrc.startsWith('https') ? `${photoSrc}?t=${new Date().getTime()}` : photoSrc;
    return (
      <div
        className="photo__container" 
        onMouseEnter={() => setIsHoveringPhoto(true)}
        onMouseLeave={() => setIsHoveringPhoto(false)}
      >
        {
          isHoveringPhoto && (
            <img className="edit__photo__icon" src={editPhotoIcon} alt="Edit photo icon" />
          )
        }
        <img src={photoSrcUrl} onError={onPhotoError} alt="photo" style={{width: '100%'}} />
      </div>
    );
  }
  return (
    <div>
      {isLoading ? <LoadingOutlined/> : <PlusOutlined/>}
      <div className="ant-upload-text">{t('photo.upload')}</div>
    </div>
  );
};

export default ProfilePhotoViewer;